import React, { useState } from "react";
import logo from "../../Assets/Images/logo.png";
import { Link } from "react-router-dom";
import { useGlobalContext } from "../../Context/GlobalContext";
import { FaTasks } from "react-icons/fa";
import { AiOutlineHome } from "react-icons/ai";
import { FaFileInvoice } from "react-icons/fa";
import { GrDocumentNotes } from "react-icons/gr";
import { GoProjectRoadmap } from "react-icons/go";
import { IoChatboxEllipsesOutline } from "react-icons/io5";
import { useLocation } from "react-router-dom";

const SidebarClient = () => {
  const {  selectedSidebarTab, setSelectedSidebarTab } = useGlobalContext();
  const location = useLocation();
   
  const handleLinkClick = (tab) => {
    // Set the selected sidebar tab
    setSelectedSidebarTab(tab);
     // Close sidebar on small screens
    if (window.innerWidth < 850) { 
       // Remove the custom class  
    document.body.classList.remove("custom-body-class"); 
  }
}

  return (
    <div className="sidebar flex-shrink-0 w-full sm:w-[340px]  md:w-[270px] bg-[#27004a] p-[5px]  sm:p-[10px]   h-[100vh]   overflow-y-scroll content-container selection pb-[57px] lg:top-[0px]">

 
      <div className="flex xl:justify-center lg:justify-center  p-[20px]">
        <img src={logo} alt="" className="w-[120px]" />
      </div>
      <ul className="pl-[2px] pr-[2px] pt-[0px] pb-[20px]">
        <Link to="/c" onClick={() => { handleLinkClick("dashboard") }} className={`flex items-center gap-[10px] hover:bg-[#fff] mb-[5px] hover:text-[#8a25b0] p-[10px]   rounded-md  transition-all ${location.pathname === "/c" ? "bg-white text-[#8a25b0]" : "text-white"}`} >
        <AiOutlineHome className="text-gray-500 text-xl"/>
          <button  className="">Dashboard</button>
        </Link>
        <Link to="/c/chats" onClick={() => { handleLinkClick("chat") }} className={`flex items-center gap-[10px] hover:bg-[#fff] mb-[5px] hover:text-[#8a25b0] p-[10px]   rounded-md  transition-all ${location.pathname === "/c/chats" ? "bg-white text-[#8a25b0]" : "text-white"}`}>
        <IoChatboxEllipsesOutline className="text-gray-500 text-xl"/>
          <button  className="">Chat</button>
        </Link>


        <div className="">
          <Link to = "/c/project_summary" onClick={() => {handleLinkClick("projects") }} className={`flex items-center gap-[10px] hover:bg-[#fff] mb-[5px] hover:text-[#8a25b0] p-[10px]   rounded-md  transition-all ${location.pathname === "/c/project_summary" ? "bg-white text-[#8a25b0]" : "text-white"}`}>
          <GoProjectRoadmap className="text-xl text-gray-500 "/>
            <button >
              Projects
            </button>

          </Link>

          {/* <div
            className={`overflow-hidden transition-max-height duration-300 ease-in-out mt-[5px] `}
          >

            <button to="#"
              className="w-full ml-[40px] text-left py-[10px] flex items-center gap-[10px] pl-[0px] whitespace-nowrap  text-white   transition-all	rounded-md"
            >
              <ArrowForwardIosIcon className="arrow-icon-sidebar"/>
              Task
            </button>
</div> */}
        </div>

        <div className="">
          <Link to="/c/task" onClick={() => { handleLinkClick("task") }} className={`flex items-center gap-[10px] hover:bg-[#fff] mb-[5px] hover:text-[#8a25b0] p-[10px]   rounded-md  transition-all ${location.pathname === "/c/task" ? "bg-white text-[#8a25b0]" : "text-white"}`}>
          <FaTasks className="text-xl text-gray-500"/>
            <button 
            >
              Task
            </button>

          </Link>

      
        </div>
        <div className="">
          <Link to = "/c/notes" onClick={() => { handleLinkClick("notes") }} className={`flex items-center gap-[10px] hover:bg-[#fff] mb-[5px] hover:text-[#8a25b0] p-[10px]   rounded-md  transition-all ${location.pathname === "/c/notes" ? "bg-white text-[#8a25b0]" : "text-white"}`}>
          <GrDocumentNotes className="text-xl text-gray-500"/>
            <button 
            >
              Notes
            </button>

          </Link>

      
        </div>
        <div className="">
          <Link  to = "/c/project_invoice" onClick={() => { handleLinkClick("invoice") }} className={`flex items-center gap-[10px] hover:bg-[#fff] mb-[5px] hover:text-[#8a25b0] p-[10px]   rounded-md  transition-all ${location.pathname === "/c/project_invoice" ? "bg-white text-[#8a25b0]" : "text-white"}`}>
          <FaFileInvoice className="text-xl text-gray-500"/> 
            <button
            >
              Invoice
            </button>

          </Link>

      
        </div>


      

       
      </ul>
    </div>
  );
};

export default SidebarClient;
